import React, { useEffect, useState } from 'react';
import MostrarPuntaje from '../componentes/MostrarPuntaje';
import { socket } from '../socket';

const Piso = () => {

    const [nombre, setNombre] = useState('');
    const [club, setClub] = useState('');
    const [scoreType, setscoreType] = useState('');
    const [dificultad, setDificultad] = useState('');
    const [ejecucion, setEjecucion] = useState('');

    useEffect(() => {
        socket.on('pisodata', data => {
            setNombre(data.nombre);
            setClub(data.club);
            setscoreType(data.scoreType);
            setDificultad(data.dificultad);
            setEjecucion(data.ejecucion); 
        });
    }, []);

    return (
        <div>
            <MostrarPuntaje aparato={"piso"} nombre={nombre} club={club} ejecucion={ejecucion} dificultad={dificultad} scoreType={scoreType}/>
        </div>
    );
};

export default Piso;
